<template>
  <div>
    <vs-row class="mt-3">
      <vs-col class="p-2" vs-xs="12" :vs-lg="context==='page'?'8':'12'" vs-sm="12">
        <vs-textarea style="min-height: 230px" class="inputx" placeholder="متن پیام را وارد کنید"
                     v-model="messageContent"/>
        <div class="mt-2">
          <vs-button @click="sendMessage" :disabled="(!users.length && !cohortsWithUsers.length) || !messageContent" color="success">ارسال پیام
          </vs-button>
        </div>
      </vs-col>
      <vs-col v-if="context==='page'" class="p-2" vs-xs="12" vs-lg="4" vs-sm="12">
        <label>افزودن دانش آموز</label>
        <select-user placeholder="افزودن دانش آموز" @change="userSelected" role="student"></select-user>
        <hr class="my-3">
        <label>افزودن راننده</label>
        <select-user placeholder="افزودن راننده" class="mt-2" @change="userSelected" role="driver"></select-user>
        <hr class="my-3">
        <label>افزودن گروه</label>
        <v-select placeholder="افزودن گروه" :options="cohortsOptions" @input="addCohort" dir="rtl">
          <span slot="no-options">موردی وجود ندارد</span>
        </v-select>
      </vs-col>
    </vs-row>
    <div class="mt-5 p-3" style="background-color: #f4f4f4">
      <div class="mt-3" v-if="students.length">
        <h4 class="my-3">دانش آموزان</h4>
        <vx-card>
          <div class="d-flex flex-wrap">
            <user-msg-card :key="`student-${user.id}`" @remove="userRemoved($event,'student')" :user="user"
                           v-for="user in students"></user-msg-card>
          </div>
        </vx-card>
      </div>
      <div class="mt-3" v-if="drivers.length">
        <h4 class="my-3">رانندگان</h4>
        <vx-card>
          <div class="d-flex flex-wrap">
            <user-msg-card :key="`driver-${user.id}`" @remove="userRemoved($event,'driver')" :user="user"
                           v-for="user in drivers"></user-msg-card>
          </div>
        </vx-card>
      </div>
      <div class="mt-3" v-if="cohortsWithUsers.length">
        <h4 class="my-3">گروه ها</h4>
        <vx-card>
          <div v-for="cohort in cohortsWithUsers" class="mb-5  ">
            <div class="d-flex p-3" style="background-color: #f4f4f4">
              <h5 v-text="cohort.name"></h5>
              <feather-icon class="cursor-pointer text-danger ml-3" @click="removeCohort(cohort.id)" icon="XIcon"
                            svgClasses="w-5 h-5 stroke-current"/>
            </div>
            <div class="d-flex flex-wrap mt-4">
              <user-msg-card @remove="userRemoved($event,'cohort',cohort.id)" :key="`cohort-${cohort.id}-${user.id}`"
                             :user="user"
                             v-for="user in cohort.users"></user-msg-card>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import SelectUser from "../../user/components/SelectUser";
  import UserMsgCard from "./UserMsgCard";
  import vSelect from 'vue-select'

  export default {
    name: "SendMessageForm",
    components: {UserMsgCard, SelectUser, 'v-select': vSelect},
    data() {
      return {
        messageContent: '',
        selectedCohortsIds: [],
        cohortsWithUsers: [],
        allUsers: [],
      }
    },
    mounted() {
      if (!this.cohorts.length)
        this.$store.dispatch('fetchCohorts')
      this.$store.dispatch('getAllUsers').then(users => {
        this.allUsers = users
        if (this.$store.state.cohort) {
          let c = {
            label: this.$store.state.cohort.name,
            value: this.$store.state.cohort.id,
          }
          this.addCohort(c)
          this.$store.commit('SET_STATE', {cohort: null})
        }
      })
    },
    methods: {
      sendMessage() {
        let userIds = this.$store.state.usersWhoNeedMsg.map(i => i.id)
        let cohortsUserIds = [];
        this.cohortsWithUsers.forEach(c => {
          c.users.forEach(u => {
            cohortsUserIds.push(u.id)
          })
        })
        userIds = [...new Set(userIds.concat(cohortsUserIds))]

        this.$http.post('message/send', {
          requester: this.$store.getters.userCredentials,
          request: {
            toUserIds: userIds,
            content: this.messageContent
          }
        })
          .then(res => {
            if (res.data.result) {
              this.$vs.notify({title: 'پیام مورد نظر ارسال شد', text: '', color: 'success', position: 'top-center'})
              this.$emit('sent')
            }
          })
          .catch(err => {
            console.log(err)
            reject(false)
          })
      },
      addUser(user) {
        this.$store.commit('USERS_WHO_NEED_MSG_CHANGED', {
          action: 'add',
          user: user
        })
      },
      userSelected(user) {
        let userIds = this.users.map(i => i.id)
        if (userIds.includes(user.id)) {
          alert('این کاربر قبلا انتخاب شده')
          return
        }
        this.addUser(user)
      },
      removeCohort(cohortId) {
        this.cohortsWithUsers = this.cohortsWithUsers.filter(i => i.id !== cohortId)
        this.selectedCohortsIds = this.selectedCohortsIds.filter(i => i !== cohortId)
      },
      userRemoved(userId, context, contextId = null) {
        if (context === 'cohort') {
          let cohort = this.cohortsWithUsers.find(i => i.id === contextId)
          cohort.users = cohort.users.filter(i => i.id !== userId);
        } else {
          this.$store.commit('USERS_WHO_NEED_MSG_CHANGED', {
            action: 'remove',
            userId: userId
          })
        }
      },
      addCohort(cohort) {
        if(cohort){
          this.selectedCohortsIds.push(cohort.value)
          let newCohort = Object.assign({}, this.cohorts.find(c => c.id === cohort.value))
          newCohort['users'] = this.allUsers.filter(u => u.groups.map(x => x.id).includes(cohort.value))
          this.cohortsWithUsers.push(newCohort)
        }
      }
    },
    computed: {
      users() {
        return this.$store.state.usersWhoNeedMsg
      },
      drivers() {
        return this.$store.state.usersWhoNeedMsg.filter(i => i.role === 'DRIVER')
      },
      students() {
        return this.$store.state.usersWhoNeedMsg.filter(i => i.role === 'STUDENT')
      },
      cohorts() {
        return this.$store.state.cohorts
      },
      cohortsOptions() {
        return this.cohorts.filter(i => !this.selectedCohortsIds.includes(i.id))
          .map(i => {
            return {
              value: i.id,
              label: i.name,
            }
          });
      }
    },
    props: {
      context: {
        Type: String,
        default: 'modal'
      }
    }
  }
</script>

<style>


  textarea.vs-textarea {
    min-height: 150px;
  }
</style>
